import { statsOnWidgetInteraction } from '../stats';
import { project } from '../initializeStats';

export const resizeAccordion = () => {
  // document.querySelectorAll('.gallery__accordion').forEach((el) => {
  //   el.querySelectorAll('.widget__item').forEach((item) => {
  //     const width = window.innerWidth > 768
  //       ? `${el.querySelector('.accordion__element_hover').getBoundingClientRect().width - el.querySelector('.accordion__element .accordion__title').getBoundingClientRect().width}px`
  //       : '100%';      
  //   });
  // });
};

export function accordion () {
  if (document.querySelectorAll('.gallery__accordion').length > 0) {
    resizeAccordion();

    document.querySelectorAll('.gallery__accordion').forEach((slider) => {
      let hoverTimeout;

      slider.querySelectorAll('.widget__item').forEach((el) => {
        el.addEventListener('mousemove', () => {
          if (project.isScrollingFlag) return;

          clearTimeout(hoverTimeout);
          hoverTimeout = setTimeout(() => {
            if (!el.classList.contains('accordion__element_hover')) {
              slider.querySelectorAll('.widget__item').forEach((acE) => {
                acE.classList.remove('accordion__element_hover');
              });

              el.classList.add('accordion__element_hover');
              statsOnWidgetInteraction(el, el.querySelector('.accordion__title').innerText);
            }
          }, 60); // opóżnienie
        });

        el.addEventListener('mouseleave', () => {
          clearTimeout(hoverTimeout);
        });
      });
    });
  }
}
